var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-plyr-video-wrapper"},[_c('vue-plyr',[_c('div',{attrs:{"data-plyr-provider":"youtube","data-plyr-embed-id":_vm.videoId}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }